module.exports = __webpack_public_path__ + "img/pie-chart-outline.png";